module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-BoldItalic.6fe53c4.eot";